import { GetAllContentCollectionQuery, SmartQueryBody } from '../../API';
import { WithFilters } from '../shared/SearchFilters';

export type ExtendedGetCollectionParams = GetAllContentCollectionQuery & {
  sort?: SortTypes;
  smartQuery?: SmartQueryBody;
};
export type CollectionSearchParams = WithFilters<ExtendedGetCollectionParams, CollectionFilterOptions>;

export enum CollectionFilterOptions {
  GENRE_FILTER = 'genre_filter',
  FOR_SIMILARS = 'for_similars',
  STATUS_FILTER = 'status_filter',
  USED_FILTER = 'used_filter',
  SHOW_DELETED = 'show_deleted',
  AUTOROTATION_FILTER = 'auto_rotation',
  HAS_SMART_QUERY = 'has_smart_query',
  HAS_ASSETS_THESE_TYPES = 'has_assets_these_types'
}

export enum SortTypes {
  SORT_RECENTLY_PUBLISHED = 'SORT_RECENTLY_PUBLISHED',
  SORT_TITLE_ALPHABETICAL = 'SORT_TITLE_ALPHABETICAL'
}

export enum ForSimilars {
  YES = 'true',
  NO = 'false'
}

export enum HasSmartQuery {
  YES = 'true',
  NO = 'false'
}

export enum AutoRotate {
  YES = 'true',
  NO = 'false'
}
